import { FC } from 'react';
import { BaseIcon, IPropsIcon } from './BaseIcon';

interface IProps extends IPropsIcon {
  isFav?: boolean;
}

export const FavoriteIcon: FC<IProps> = ({ size = 15, fill = 'none' }) => {
  return (
    <BaseIcon size={size} viewBox='0 0 15 14' fill={fill}>
      <path
        d='M13.1328 1.97266C11.6289 0.714844 9.41406 0.90625 8.01953 2.35547L7.5 2.90234L6.95312 2.35547C5.83203 1.20703 3.58984 0.496094 1.83984 1.97266C0.117188 3.44922 0.0351562 6.07422 1.56641 7.66016L6.87109 13.1289C7.03516 13.293 7.25391 13.375 7.47266 13.375C7.71875 13.375 7.9375 13.293 8.10156 13.1289L13.4062 7.66016C14.9375 6.07422 14.8555 3.44922 13.1328 1.97266ZM12.7773 7.05859L7.5 12.5273L2.19531 7.05859C1.15625 5.96484 0.9375 3.91406 2.41406 2.65625C3.91797 1.37109 5.66797 2.30078 6.32422 2.95703L7.5 4.16016L8.64844 2.95703C9.27734 2.30078 11.0547 1.37109 12.5586 2.65625C14.0352 3.91406 13.8164 5.96484 12.7773 7.05859Z'
        fill='#717476'
      />
    </BaseIcon>
  );
};
